<!--输入桩号-->
<template>
  <div class="container">
    <div class="search-content-box">
      <div class="search-content">
        <img src="../../picture/index/search.png" class="search-icon" />
        <div class="search-input-box">
          <input
            class="search-input"
            @input="inputChange"
            v-model="searchValue"
            placeholder="请输入充电站名称"
          />
        </div>
      </div>
    </div>
    <div scroll-y="true" class="container-flex station-list-container">
      <div class="station-ul">
        <div
          class="station-li"
          v-for="(item, index) in stationListShow"
          :key="index"
        >
          <pi-station-item
            :item="item"
            @change="collected"
            :index="index"
          ></pi-station-item>
        </div>
      </div>
      <pi-no-list-data :list="stationListShow" text="暂无搜索的充电站">
        <img src="../../picture/no-data-icon/order.png" class="no-list-icon" />
      </pi-no-list-data>
    </div>
  </div>
</template>

<script>
import stationItem from "@/components/pi-station-item/pi-station-item.vue";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
import { forStationList } from "@/common/common-data";
import { getStationList } from "../../common/api";
export default {
  name: "home-search-sta",
  data() {
    return {
      stationList: [],
      stationListShow: [],
      staParam: {
        distance: null,
        pileStatus: 0,
        speedTypes: [],
        oprTagPkIds: [],
        globalPageIndex: 1,
        globalPageSize: 2000,
        userLat: 22.53332,
        userLng: 113.93041,
        appType: 1,
      },
      searchValue: ''
    };
  },
  components: {
    [stationItem.name]: stationItem,
    [noListData.name]: noListData,
  },
  mounted() {
    let staParam = this.$common.get("staParam");
    if (staParam) {
      this.staParam = Object.assign(this.staParam, staParam);
    }
    this.handleGetStationList();
  },
  methods: {
    /**
     * 请求站点列表
     * @param {} call
     */
    async handleGetStationList() {
      let ret = await getStationList(this.staParam, { loading: false });
      if (ret.data && ret.data.length > 0) {
        let list = forStationList(ret.data);
        this.stationList = list;
      } else {
        this.stationList = [];
      }
    },
    /**
     * 收藏点击，组件里已经请求成功
     * @param {*} e
     */
    collected(item) {
      let index = item.index;

      this.stationListShow[index] = item;
      let staPkId = item.staPkId;
      this.stationList.map((stationItem) => {
        if (stationItem.staPkId == staPkId) {
          stationItem.ifCollected = item.ifCollected;
        }
      });
    },
    /**
     * 搜索框输入时
     * @param {*} e
     */
    inputChange() {
      let value = this.searchValue;
      let stationListShow = [];
      if (value != "") {
        stationListShow = this.stationList.filter((item) => {
          return item.staName.indexOf(value) != -1;
        });
      }
      this.stationListShow = stationListShow;
    },
  },
};
</script>

<style lang="less" scoped>
.search-content-box {
  padding: 0.16rem 0.4rem;
  background-color: #fff;
}
.search-content {
  background-color: #f5f5f5;
  border-radius: 0.4rem;
  position: relative;
  padding: 0.1rem 0;
}
.search-content .search-icon {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  left: 0.05rem;
  top: 0.14rem;
}
.search-content .search-input-box {
  padding: 0 0.1rem 0 0.52rem;
  font-size: 0.24rem;
  line-height: 0.56rem;
  height: 0.56rem;
}
.search-content .search-input-box .search-input {
  width: 100%;
  height: 100%;
  font-size: 0.28rem;
  line-height: 0.56rem;
  color: #333;
  background: transparent;
}

.station-ul {
  padding: 0 0.2rem 0rem 0.2rem;
  box-sizing: border-box;
}
.station-ul .station-li {
  margin-top: 0.2rem;
}
</style>
